import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { adminLogin } from './adminApi';
import { inputStyle, labelStyle } from '../quote/quoteStyles';

export const InboxLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await adminLogin(password);
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '420px', margin: '0 auto', backgroundColor: 'var(--bg-card)', border: '1px solid var(--border-medium)', borderRadius: '12px', padding: '2.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1.5rem' }}>
        <Lock size={24} color="var(--brand-primary)" />
        <h2 className="heading-3" style={{ margin: 0 }}>Staff sign-in</h2>
      </div>
      <form onSubmit={submit} data-testid="inbox-login-form">
        <label htmlFor="inbox-password" style={labelStyle}>Inbox password</label>
        <input id="inbox-password" data-testid="inbox-password-input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} style={{ ...inputStyle, marginBottom: '1rem' }} />
        {error && <p data-testid="inbox-login-error" role="alert" style={{ color: '#c53030', fontSize: '0.9rem', marginBottom: '1rem' }}>{error}</p>}
        <button type="submit" className="btn-primary" data-testid="inbox-login-button" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};
